import { render, staticRenderFns } from "./glfp12m.vue?vue&type=template&id=683481d6"
import script from "./glfp12m.vue?vue&type=script&lang=js"
export * from "./glfp12m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports